import React, { useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  CircularProgress,
  Typography,
  Box
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { API_BASE_URL } from 'src/apiConfig';

/* ADMIN MODAL - RESET LOZINKE */
const ResetPasswordModal = ({ open, onClose, user }) => {
  const { t } = useTranslation();
  const [newPassword, setNewPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleResetWithPassword = async () => {
    setIsLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/api/auth.php`, {
        action: 'changePasswordAdmin',
        username: user.userName,
        newPassword
      });
      setIsLoading(false);
      onClose();
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleGeneratePassword = () => {
    const generatedPassword = Math.random().toString(36).slice(-8);
    setNewPassword(generatedPassword);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          padding: '10px',
          borderRadius: '8px',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)'
        }
      }}
    >
      <DialogTitle
        sx={{
          fontSize: '1.4rem',
          fontWeight: '600',
          color: '#2979ff',
          textAlign: 'center',
          marginBottom: '5px'
        }}
      >
        {t('dialog.resetPasswordTitle', { user: user.userName })}
      </DialogTitle>

      <DialogContent sx={{ padding: '10px' }}>
        {/* Smanjen padding */}
        <Typography
          variant="body1"
          sx={{
            marginBottom: '15px',
            color: '#333',
            textAlign: 'center',
            fontWeight: '500'
          }}
        >
          {t('dialog.resetPasswordInstruction')}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '10px'
          }}
        >
          <TextField
            label={t('dialog.newPassword')}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            fullWidth
            sx={{
              marginRight: '5px',
              backgroundColor: '#f5f5f5',
              borderRadius: '6px',
              padding: '5px'
            }}
          />
          <Button
            onClick={handleGeneratePassword}
            sx={{
              backgroundColor: '#4caf50',
              color: '#fff',
              padding: '5px 10px',
              minWidth: '40px',
              borderRadius: '6px',
              '&:hover': {
                backgroundColor: '#388e3c'
              }
            }}
          >
            <RefreshIcon />
          </Button>
        </Box>
        <Typography
          variant="body2"
          sx={{
            color: '#666',
            textAlign: 'center',
            marginBottom: '10px'
          }}
        >
          {t('dialog.generatedPasswordInfo')}
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: 'space-between',
          padding: '10px'
        }}
      >
        <Button
          onClick={onClose}
          sx={{
            backgroundColor: '#e0e0e0',
            color: '#666666',
            padding: '5px 15px',
            fontWeight: '500',
            textTransform: 'none',
            borderRadius: '6px',
            '&:hover': {
              backgroundColor: '#d5d5d5'
            }
          }}
        >
          {t('dialog.cancel')}
        </Button>

        <Button
          onClick={handleResetWithPassword}
          sx={{
            backgroundColor: '#2979ff',
            color: '#fff',
            padding: '5px 15px',
            fontWeight: '600',
            textTransform: 'none',
            borderRadius: '6px',
            '&:hover': {
              backgroundColor: '#1565c0'
            }
          }}
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress size={24} sx={{ color: '#fff' }} />
          ) : (
            t('dialog.confirm')
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetPasswordModal;
